module.exports = {"resetEmail.modal.description":"メールアドレスを入力してください。パスワードをリセットするためのメールをお送りします。メールが届かない場合は、スパム/プロモーションフォルダを確認し、別のメールまたはサインイン方法（GoogleサインインまたはApple ID）を試してください。","resetEmail.modal.action.buttonLabel":"メールを送る","resetEmail.action.email.sent":"メールアドレスと迷惑メールフォルダを確認してください。メールを受け取っていない場合は、別のログイン方法（GoogleログインまたはApple ID）を使用したか、このメールの下にアカウントが存在しない可能性があります。"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ja/components/ModalContent/ResetEmail.json
// module id = 835
// module chunks = 0